import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import ImageUpload from "@/components/admin/ImageUpload";
import { useSettingsEditor, SaveBar } from "@/components/admin/useSettingsEditor";

export default function AdminBranding() {
  const { draft, patchPath, save, reset, saving } = useSettingsEditor();
  if (!draft) return null;
  const b = draft.branding || {};

  return (
    <div data-testid="cms-branding-page">
      <div className="mb-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] brand-secondary-text mb-2">Identity</p>
        <h1 className="font-heading text-3xl sm:text-4xl text-slate-900">Branding & Logo</h1>
        <p className="text-slate-500 mt-2">Change the college name, tagline and upload logos used across the website.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] p-6 sm:p-8 space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <Label className="text-slate-700 text-sm">Full College Name</Label>
            <Input data-testid="cms-college-name" value={b.collegeName || ""} onChange={(e) => patchPath("branding.collegeName", e.target.value)} className="mt-1.5 h-11 rounded-xl border-slate-200" />
          </div>
          <div>
            <Label className="text-slate-700 text-sm">Short Name (Header)</Label>
            <Input data-testid="cms-short-name" value={b.shortName || ""} onChange={(e) => patchPath("branding.shortName", e.target.value)} className="mt-1.5 h-11 rounded-xl border-slate-200" />
          </div>
          <div>
            <Label className="text-slate-700 text-sm">Header Subtitle</Label>
            <Input value={b.navSubtitle || ""} onChange={(e) => patchPath("branding.navSubtitle", e.target.value)} className="mt-1.5 h-11 rounded-xl border-slate-200" />
          </div>
          <div className="sm:col-span-2">
            <Label className="text-slate-700 text-sm">Tagline (used in footer)</Label>
            <Textarea data-testid="cms-tagline" value={b.tagline || ""} onChange={(e) => patchPath("branding.tagline", e.target.value)} className="mt-1.5 rounded-xl border-slate-200 min-h-[80px]" />
          </div>
        </div>

        <div className="border-t border-slate-100 pt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ImageUpload
            label="Dark Logo (for light backgrounds — header, admin panel)"
            value={b.logoDark}
            onChange={(url) => patchPath("branding.logoDark", url)}
            folder="logos"
            testid="upload-logo-dark"
            height={140}
          />
          <ImageUpload
            label="Light Logo (for dark backgrounds — footer)"
            value={b.logoLight}
            onChange={(url) => patchPath("branding.logoLight", url)}
            folder="logos"
            testid="upload-logo-light"
            height={140}
          />
        </div>

        <div className="border-t border-slate-100 pt-6 flex items-center gap-3">
          <Switch checked={b.showLogoImage !== false} onCheckedChange={(v) => patchPath("branding.showLogoImage", v)} />
          <div>
            <p className="text-sm text-slate-700 font-medium">Show uploaded logos on the site</p>
            <p className="text-xs text-slate-500">Turn off to fall back to the default heart-pulse icon mark.</p>
          </div>
        </div>
      </div>

      <SaveBar onSave={save} onReset={reset} saving={saving} />
    </div>
  );
}
